import React, { useState } from 'react';
import './Listings.css';
import PropertyCard from '../PropertyCard/PropertyCard';
import FeaturedPanel from '../FeaturedPanel/FeaturedPanel';
import KrishnaVatikaModal    from '../KrishnaVatikaModal/KrishnaVatikaModal';
import LotusGreensModal      from '../LotusGreensModal/LotusGreensModal';
import SrishtiModal          from '../SrishtiModal/SrishtiModal';
import BollywoodFarmsModal   from '../BollywoodFarmsModal/BollywoodFarmsModal';

const properties = [
  {
    id: 1,
    price: 'Rs 57 Lac*',
    address: 'Krishna Vatika, Greater Noida West',
    beds: 4, rooms: 4, sqft: 2550,
    image: '/image/krishna-vatika.webp',
    hot: false, liked: false,
    modalType: 'krishnavatika',
    brochure: '/brochure/KV.pdf',
    brochureName: 'Krishna_Vatika_Brochure.pdf',
  },
  {
    id: 2,
    price: 'Rs 65 Lac*',
    address: 'Lotus Greens Villa 2, Greater Noida West',
    beds: 3, rooms: 5, sqft: 1610,
    image: '/image/loutusgreenvilla.png',
    hot: true, liked: true,
    modalType: 'lotusgreens',
    brochure: '/brochure/LG.pdf',
    brochureName: 'Lotus_Greens_Villa2_Brochure.pdf',
  },
  {
    id: 3,
    price: 'Rs 45 Lac*',
    address: 'Aalayam Srishti Villas, Greater Noida West',
    beds: 2, rooms: 5, sqft: 1862,
    image: '/image/ShrishtiHeights.webp',
    hot: false, liked: false,
    modalType: 'srishti',
    brochure: '/brochure/ASV.pdf',
    brochureName: 'Aalayam_Srishti_Villas_Brochure.pdf',
  },
  {
    id: 4,
    price: '₹20K / Sq.Yd.',
    address: 'Bollywood Aero City Farms, Yamuna Expressway',
    beds: 0, rooms: 0, sqft: 9000,
    image: '/image/bollywoodaerocity.jpeg',
    hot: true, liked: false,
    modalType: 'bollywoodfarms',
    brochure: '/brochure/BAF.pdf',
    brochureName: 'Bollywood_AeroCity_Farms_Brochure.pdf',
  },
];

const hintColors = {
  krishnavatika:  'linear-gradient(135deg, #7B2D8B, #1B6EF3)',
  lotusgreens:    'linear-gradient(135deg, #1B6B2E, #4CAF50)',
  srishti:        'linear-gradient(135deg, #C0176B, #E040A0)',
  bollywoodfarms: 'linear-gradient(135deg, #8B6914, #C8A84B)',
};

export default function Listings() {
  const [openModal, setOpenModal] = useState(null);

  const handleCardClick = (e, modalType) => {
    // Don't open modal if clicking on action buttons
    if (e.target.closest('.card-actions')) return;
    if (e.target.closest('.bv-overlay')) return;
    if (e.target.closest('.cert-overlay')) return;
    setOpenModal(modalType);
  };

  return (
    <section className="listings">
      <div className="section-header">
        <h2>Featured Properties</h2>
        <a href="#listings" className="view-all">
          View all <i className="fa fa-arrow-right" />
        </a>
      </div>

      <div className="listings-container">
        <div className="property-grid">
          {properties.map(p => (
            <div
              key={p.id}
              onClick={p.modalType ? (e) => handleCardClick(e, p.modalType) : undefined}
              className={p.modalType ? 'kv-clickable' : ''}
            >
              {p.modalType && (
                <div
                  className="kv-view-details-hint"
                  style={{ background: hintColors[p.modalType] }}
                >
                  <i className="fa fa-eye" /> View Full Details
                </div>
              )}
              <PropertyCard property={p} />
            </div>
          ))}
        </div>
        <FeaturedPanel />
      </div>

      {openModal === 'krishnavatika'  && <KrishnaVatikaModal  onClose={() => setOpenModal(null)} />}
      {openModal === 'lotusgreens'    && <LotusGreensModal    onClose={() => setOpenModal(null)} />}
      {openModal === 'srishti'        && <SrishtiModal        onClose={() => setOpenModal(null)} />}
      {openModal === 'bollywoodfarms' && <BollywoodFarmsModal onClose={() => setOpenModal(null)} />}
    </section>
  );
}
